import { ADMINISTRATOR_CONFIGURATION_EMAIL_RATE_LIMITER_ID } from '../constants/adminConfigurationConstants'
import BaseApi from './BaseApi'

class AdministratorConfigurationApi extends BaseApi {
  get administratorsUrl () {
    return 'adminConfigurations'
  }

  getEmailRateLimiter () {
    return this.getJson(`${this.administratorsUrl}/${ADMINISTRATOR_CONFIGURATION_EMAIL_RATE_LIMITER_ID}`)
  }

  updateEmailRateLimiter (payload) {
    return this.putJson(`${this.administratorsUrl}/${ADMINISTRATOR_CONFIGURATION_EMAIL_RATE_LIMITER_ID}`, payload)
  }
}

export default AdministratorConfigurationApi
